import type { AxiosInstance } from 'axios';
import {
	documentQuery,
	isResponseStatus,
	useAxiosInstance,
	usePoQuery,
} from '@gov-nx/api';

export const useDocumentFirstFile = (documentId: number | undefined) => {
	const { axiosInstance } = useAxiosInstance();

	const documentFileQuery = usePoQuery(
		{
			queryKey: [documentId],
			queryFn: async () => {
				if (!documentId) {
					return null;
				}
				return documentQuery(axiosInstance)(documentId);
			},
			retry: false,
			refetchOnWindowFocus: false,
		},
		{ errorIgnoreFilter: isResponseStatus(404) }
	);

	const souborId = documentFileQuery.data?.soubory?.[0]?.souborId;

	return souborId;
};

export const getDocumentFirstFileId = async (
	axiosInstance: AxiosInstance,
	{
		documentId,
		onError,
	}: {
		documentId: number;
		onError?: (e: unknown) => void;
	}
) => {
	let souborId: string | undefined;
	try {
		souborId = (await documentQuery(axiosInstance)(documentId)).soubory?.[0]
			.souborId;
	} catch (e) {
		onError && onError(e);
	}
	return souborId;
};
